export const messages = {
  en: {
    shopLogin: {
      welcomeBack: 'Welcome Back',
      enterCredentials: 'Please enter your credentials to continue',
      usernamePlaceholder: 'Enter your username',
      passwordPlaceholder: 'Enter your password',
      codePlaceholder: 'Enter verification code',
      refreshCode: 'Click to refresh code',
      signIn: 'Sign In',
      signingIn: 'Signing In...',
      noAccount: "Don't have an account?",
      register: 'Register Now',
      usernameRequired: 'Username is required',
      usernameLength: 'Username must be between 3 and 20 characters',
      passwordRequired: 'Password is required',
      passwordLength: 'Password must be between 6 and 20 characters',
      codeRequired: 'Verification code is required',
      codeLength: 'Verification code must be 4 characters',
      loginSuccess: 'Login successful',
      loginFailed: 'Login failed, please try again'
    }
  },
  zh: {
    shopLogin: {
      welcomeBack: '欢迎回来',
      enterCredentials: '请输入您的登录信息',
      usernamePlaceholder: '请输入用户名',
      passwordPlaceholder: '请输入密码',
      codePlaceholder: '请输入验证码',
      refreshCode: '点击刷新验证码',
      signIn: '登录',
      signingIn: '登录中...',
      noAccount: '还没有账号？',
      register: '立即注册',
      usernameRequired: '用户名不能为空',
      usernameLength: '用户名长度必须在3-20个字符之间',
      passwordRequired: '密码不能为空',
      passwordLength: '密码长度必须在6-20个字符之间',
      codeRequired: '验证码不能为空',
      codeLength: '验证码必须是4位',
      loginSuccess: '登录成功',
      loginFailed: '登录失败，请重试'
    }
  }
}